import React from "react";
import { MapPin } from "lucide-react";

/**
 * Shared location pin. Reads structured coords from `message.metadata.location`
 * (populated by the backend universal parser); falls back to `content` for
 * legacy rows stored before structured parsing shipped.
 */
const LocationMessage = ({ message }) => {
  const loc = message.metadata?.location || {};
  const { latitude, longitude, name, address } = loc;
  const hasCoords = latitude != null && longitude != null;
  const mapsUrl = hasCoords
    ? `https://www.google.com/maps?q=${latitude},${longitude}`
    : null;

  const body = (
    <>
      <span className="wa-msg__location-map">
        <MapPin size={28} />
      </span>
      {name && <span className="wa-msg__location-name">{name}</span>}
      {address && <span className="wa-msg__location-addr">{address}</span>}
      {!name && !address && (
        <span className="wa-msg__location-name">{message.content || "📍 Location"}</span>
      )}
      {hasCoords && <span className="wa-msg__location-link">Open in Maps</span>}
    </>
  );

  return mapsUrl ? (
    <a className="wa-msg__location" href={mapsUrl} target="_blank" rel="noreferrer">
      {body}
    </a>
  ) : (
    <div className="wa-msg__location">{body}</div>
  );
};

export default LocationMessage;
